export const ADMIN_LOGOUT_REQUEST = "ADMIN_LOGOUT_REQUEST";
export const ADMIN_LOGOUT_RECEIVE = "ADMIN_LOGOUT_RECEIVE";
export const ADMIN_LOGOUT_FAILURE = "ADMIN_LOGOUT_FAILURE";
export const RESET_ADMIN_LOGOUT = "RESET_ADMIN_LOGOUT";
